import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { nesdata } from "../../../Utils/Apis";

export const usePartners = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { post } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data, status } = await post(nesdata, { needkey: ["partners"] });
    if (+status == 200) {
      setData(data);
    }
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return {
    data,
    loading,
  };
};
